import permission from '../utils/permission';
export default {
    computed: {
        /**
         * 缓存key
         */
        $cacheKey() {
            return this.$route.fullPath;
        },
        /**
         * 缓存信息
         */
        $cache() {
            return this.$store.getters['cache/getCache'](this.$cacheKey);
        }
    },
    methods: {
        /**
         * 保存到缓存
         * @param options
         */
        $saveCache(options) {
            this.$store.dispatch('cache/setCache', {
                key: this.$cacheKey,
                options: options
            });
        },
        /**
         * 验证权限
         * @param code
         */
        $has(code) {
            return permission.getMenuByCode(this.$store.state.sidebar.menuList, code);
        }
    }
};
